import styled from 'styled-components'
import Flex from 'components/Flex'
import { COLORS } from 'theme'

export const Container = styled(Flex)`
  width: 100%;
  height: ${props => (props?.height ? props?.height : 'auto')};
  background-color: #fafafb;
  overflow: auto;
  &::-webkit-scrollbar {
    display: none;
  }
`
export const ContainerWrapper = styled(Flex)`
  width: 100%;
  height: ${props => (props?.height ? props?.height : 'auto')};
  background-color: #fafafb;
  overflow: auto;
  &::-webkit-scrollbar {
    display: none;
  }
  justify-content: center;
`
export const SubContainer = styled(Flex)`
  width: 25%;
  margin-top: 80px;
  margin-left: 8%;
  @media only screen and (max-device-width: 767px) {
    margin-left: 10px;
  }
`
export const SubContainerWrapper = styled(Flex)`
  width: 25%;
  margin-top: 80px;
  @media only screen and (max-device-width: 767px) {
    margin-left: 10px;
  }
   background-color: #ffffff;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0px 4px 12px rgba(153, 153, 153, 0.1);
    height: fit-content;
    margin-right: 20px;
    width: fit-content;
    padding-right: 50px;
    padding-top: 26px;
    padding-bottom: 0px;
`
export const ProgressContainer = styled(Flex)`
  width: 25%;
  justify-content: end;
  @media only screen and (max-device-width: 767px) {
    width: 0%;
    display: none;
  }
`

export const Wrapper1 = styled(Flex)`
  width: ${props => (props?.width ? props?.width : '50%')};
  margin-top: 32px;
  padding-right:5px;
overflow-y: scroll;
::-webkit-scrollbar {
  width: 6px; /* Adjust the width as needed */
}

/* Style the scrollbar thumb */
::-webkit-scrollbar-thumb {
  background-color: #8c92b5b5; /* color of the scrollbar thumb */
  border-radius: 3px;
  cursor: grabbing /* roundness of the scrollbar thumb */
}
  @media only screen and (max-device-width: 767px) {
    width: 75%;
  }
  
`

export const Wrapper = styled(Flex)`
  width: ${props => (props?.width ? props?.width : '50%')};
  margin-top: 32px;
  @media only screen and (max-device-width: 767px) {
    width: 75%;
  }
  
`
export const WrapperContainer = styled(Flex)`
  width: ${props => (props?.width ? props?.width : '50%')};
      margin-top: 48px;
    background-color: #ffffff;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0px 4px 12px rgba(153, 153, 153, 0.1);
  @media only screen and (max-device-width: 767px) {
    width: 75%;
  }
`

export const Left = styled.div`
  margin-top: 75px;
  width: 40%;
  height: auto;
  position: absolute;
  background-color: #fafafb;
`

export const Right = styled.div`
  margin-top: 20px;
  width: 60%;
  height: auto;
  padding-top: 15px;
  right: 300px;
  position: absolute;
`

export const H2 = styled.div`
  font-weight: 700;
  font-size: 1.2857142857142858em;
  line-height: 24px;
  color: #4d566e;
  margin-top: ${props => (props.marginTop ? props.marginTop : null)};
`

export const Heading = styled.div`
  font-weight: 700;
  font-size: 1.7em;
  line-height: 30px;
  color: #1b1f22;
`

export const Content = styled.div`
  margin-top: 33px;
  box-shadow: 0px 4px 12px rgba(153, 153, 153, 0.1);
  border-radius: 10px;
  width: 100%;
  background-color: #ffffff;
  padding: 50px 75px;
`


export const ContentContainer = styled.div`
  margin-top: 19px;
  box-shadow: 0px 4px 12px rgba(153, 153, 153, 0.1);
  border-radius: 10px;
  width: 100%;
  background-color: #ffffff;
  padding: 50px 75px;
  overflow: auto;
  margin-bottom: 20px;
    /* Hide default scrollbar */
    ::-webkit-scrollbar {
        width: 6px; /* Adjust the width as needed */
    }

    /* Style the scrollbar thumb */
    ::-webkit-scrollbar-thumb {
        background-color: #8c92b5b5; /* color of the scrollbar thumb */
        border-radius: 3px;
        cursor: grabbing /* roundness of the scrollbar thumb */
    }
`

export const StyeledDiv = styled.div`
background : yellow;
/* Hide default scrollbar */
::-webkit-scrollbar {
    width: 6px; /* Adjust the width as needed */
}

/* Style the scrollbar thumb */
::-webkit-scrollbar-thumb {
    background-color: #8c92b5b5; /* color of the scrollbar thumb */
    border-radius: 3px;
    cursor: grabbing /* roundness of the scrollbar thumb */
}
`
export const ValidateMessage = styled.div`
  font-weight: 500;
  font-size: 0.8em;
  color: red;
`

export const SubHeading = styled(Flex)`
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  margin-bottom: 15px;
  color: ${COLORS.GREY_P_100};
  `

export const ProgroressBar = styled.div`
  width: 10%;
  position: fixed;
`
